import axios from './axios'
import * as model from '../models/patient';

export async function getStatiMatrimoniali() {
  const response = await axios.get(`api/statimatrimoniali`);
  return response.data as model.StatiMatrimoniali[];
}

export async function getcareProviders() {
  const response = await axios.get(`api/careProviders`);
  return response.data as model.Careprovider[];
}


export function getLivelliConfidenzionalita() {
  const stateList = [
    {
      value: 1,
      label: 'Nessuna Restrizione'
    },
    {
      value: 2,
      label: 'Basso'
    },
    {
      value: 3,
      label: 'Moderato'
    }
  ];
  return stateList as model.EshDictionary[];

}



export function getStatiDiagnosi() {

  const stateList = [
    {
      value: 1,
      label: 'Sospetta'
    },
    {
      value: 0,
      label: 'Confermata'
    },
    {
      value: 2,
      label: 'Esclusa'
    }
  ];
  return stateList as model.EshDictionary[];
}
export function getStatiIndagini() {

  const stateList = [
    {
      value: 1,
      label: 'Programmata'
    },
    {
      value: 0,
      label: 'Richiesta'
    },
    {
      value: 2,
      label: 'Completa'
    },

  ];
  return stateList as model.EshDictionary[];
}

export function getLiveliVisibilita() {

  const liveliVisibilita = [
    {
      value: 1,
      label: 'Totale'
    },
    {
      value: 3,
      label: 'Parziale'
    },
    {
      value: 2,
      label: 'Minima'
    },

  ];
  return liveliVisibilita as model.EshDictionary[];
}

export function getDonorStatus() {
  const approvalStatus = [
    {
      label: "Non acconsento",
      value: "0"
    },
    {
      label: "Acconsento",
      value: "1"
    }
  ];
  return approvalStatus;
}
export function getBloodType() {

  const bloodGroupList = [
    {
      label: '0+ (Gruppo Zero, Rh Positivo)',
      value: '0 +',
    },
    {
      label: '0- (Gruppo Zero, Rh Negativo)',
      value: '0 -',
    },
    {
      label: 'A+ (Gruppo A, Rh Positivo)',
      value: 'A +',
    },
    {
      label: 'A- (Gruppo A, Rh Negativo)',
      value: 'A -',
    },
    {
      label: 'B+ (Gruppo B, Rh Positivo)',
      value: 'B +',
    },
    {
      label: 'B- (Gruppo B, Rh Negativo)',
      value: 'B -',
    },
    {
      label: 'AB+ (Gruppo AB, Rh Positivo)',
      value: 'AB +',
    },
    {
      label: 'AB- (Gruppo AB, Rh Negativo)',
      value: 'AB -',
    }
  ]

  return bloodGroupList as model.bloodGroup[];


}


